import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("netcrm_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("netcrm_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("netcrm_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("netcrm_token"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("netcrm_token", r.data.token);
    localStorage.setItem("netcrm_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (name, email, password) => {
    const r = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("netcrm_token", r.data.token);
    localStorage.setItem("netcrm_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("netcrm_token");
    localStorage.removeItem("netcrm_user");
    setUser(null);
  };

  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    localStorage.setItem("netcrm_user", JSON.stringify(r.data));
    return r.data;
  };

  const loginWithGoogle = async (session_id) => {
    const r = await api.post("/auth/google", { session_id });
    localStorage.setItem("netcrm_token", r.data.token);
    localStorage.setItem("netcrm_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refreshUser, setUser, loginWithGoogle }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
